module.exports = __webpack_public_path__ + "static/media/window-frame-open.8cc5b3f8.svg";